/**
 * Copyright © Veeam Software Group GmbH.
 */

export const extractCountryId = (mapId: string): string => mapId.split('-')[0]; // extractCountryId('us-ca') => 'us'
